export const AUTH_SESSION_ID = 'Mtl-Pyxis-Session-Id';
